import { DeviceInfo } from '../DeviceInfo';

export class SendEmailStartedEventArgs {
    public deviceInfo: DeviceInfo;
    public format: string;
    public handled: boolean = false;

    constructor(deviceInfo: DeviceInfo, format: string) {
        this.deviceInfo = deviceInfo;
        this.format = format;
    }
}
